var map = {
	"./JavaScript.svg": 4488,
	"./arrow.svg": 12,
	"./ascendion_logo.svg": 6859,
	"./bh_logo.svg": 9843,
	"./bug.svg": 7217,
	"./bulb.svg": 7748,
	"./carrot.svg": 8620,
	"./checklist.svg": 1991,
	"./close.svg": 5871,
	"./cognomotiv_logo.svg": 2458,
	"./collabera_logo.svg": 7086,
	"./css3.svg": 5953,
	"./css_icon.svg": 802,
	"./desktop.svg": 9983,
	"./devops.svg": 8730,
	"./devops_icon.svg": 1758,
	"./drupal.svg": 1355,
	"./drupal_logo.svg": 8407,
	"./drupal_svg.svg": 1760,
	"./experience_icon.svg": 7459,
	"./faq.svg": 8743,
	"./globe.svg": 4060,
	"./handshake.svg": 6736,
	"./html.svg": 4478,
	"./html_icon.svg": 7474,
	"./ic-service-ai.svg": 9422,
	"./ic-service-custom.svg": 3805,
	"./ic-service-product.svg": 8953,
	"./ic-service-web.svg": 670,
	"./javascript_icon.svg": 7840,
	"./logomark.svg": 3787,
	"./money_icon.svg": 6217,
	"./monitor.svg": 8205,
	"./mysql.svg": 2421,
	"./notes.svg": 2596,
	"./our_story.svg": 5319,
	"./php.svg": 1623,
	"./php_icon.svg": 1553,
	"./react_icon.svg": 9330,
	"./services.svg": 1441,
	"./sql_icon.svg": 9821,
	"./support_icon.svg": 3530,
	"./tandev_logo.svg": 4967,
	"./tandev_logo_main.svg": 6669,
	"./tandev_logo_small.svg": 2863,
	"./teamwork.svg": 5905,
	"./tech_worker_man.svg": 9639,
	"./tech_worker_woman.svg": 2201,
	"./think_logo.svg": 6239,
	"./wordpress_logo.svg": 6304,
	"./wrench.svg": 4690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9109;